const BannerData = {
  videoUrl:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FCanival_Web.mp4?alt=media&token=579a902e-4acf-48ca-a10b-86712c123da5",
  title: "The new Kia Carnival Limousine",
  subtitle: "Your own luxury liner.",
  price: "",
  features: [],
};

const banner2Data = {
  imgSrc:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Carnival%2FB-1-d.jpg?alt=media&token=191c351b-3256-4395-856a-866abe886e8a",
  data: [
    {
      title: "Mile-High Safety",
      description: "",
    },
    {
      title: "Dual Panoramic Curved Display",
      description: "",
    },
    {
      title: "Wide Electric Dual Sunroof",
      description: "",
    },
  ],
};

const IntroData = {
  heading: "Your own luxury liner.",
  subheading: "",
  description:
    "With a bold grille, dazzling projection headlamps, and design that turns heads, The new Carnival is here to announce your arrival in unparalleled style.The new Carnival Limousine is more than a car; it's an experience. It gives wings to finely crafted comfort and envelops you in opulence. Step in, and you'll forget you're still on the ground.",
  image:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fluxuary1.webp?alt=media&token=ef3e3ca7-797a-4dd1-b168-a3b225be6491",
};

const InterestDealerData = {
  disclaimer: "",
  register:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2Fregister%20intrest.png?alt=media&token=2c5fb2a2-418b-4399-8994-8e590bd17314",
  dealer:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FBrochure%20image.png?alt=media&token=5ce8b8e6-2d25-41f1-b458-69aa2bd51a10",
};

const CarouselData = [
  {
    sub: "LIMOUSINE+",
    title: "Extravagance. Reborn.",
    data: "Engineered to make every journey a first-class experience, the Kia Carnival Limousine+ sets the new standard for luxury, and innovation.​​",
    carData: [
      {
        title: "Front LED Fog Lamps",
        description:
          "Cut through the mist and navigate the path ahead with the ease.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLP-1.webp?alt=media&token=c2879ec1-989a-493a-9ea0-ab7e0f8a0349",
      },
      {
        title:
          "2nd Row Powered Relaxation Seats with Ventilation, Heating and Leg Support",
        description:
          "Cruise with elegance for a journey more extravagant than the destination.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLP-2.webp?alt=media&token=d51d13de-6493-4d8d-8384-0efe4887dcde",
      },
      {
        title: "Bose Premium Surround Sound with 12 Speakers",
        description:
          "Let every note and every symphony take flight and fill your private cabin.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLP-3.webp?alt=media&token=4f14d3dc-1606-43c0-be96-e587cb92b2ed",
      },
      {
        title: "Front Console Wireless Smartphone Charger",
        description:
          "Charge up and take off with the convenience of a wireless smartphone charger. No cables. No limits.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLP-4.webp?alt=media&token=bc1b8222-e845-45ef-b155-53e5d06878d0",
      },
      {
        title: "Wide Electric Dual Sunroof",
        description:
          "Limitless views for you, as if from an attitude of 30,000 feet in the sky.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLP-5.webp?alt=media&token=0a1b8034-98f0-4594-8fac-c0a1fc849a12",
      },
      {
        title: "Advanced Head-up Display",
        description: "A personalised panel for your Digital Cockpit",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLP-6.webp?alt=media&token=68a571d4-6f24-44c4-acf5-412747081cb3",
      },
    ],
  },
  {
    sub: "LIMOUSINE",
    title: "Take off with Luxury.",
    data: "Built, and crafted to refine your journeys, every innovative and extravagant detail of the new Kia Carnival Limousine is meant to be your portal to sheer opulence.​",
    carData: [
      {
        title: "R18 - 45.72 Cm (18”) Diamond Cut Alloy",
        description:
          "Take off in style with Black and Chrome coating B-Type Radiator Grille in the Alloy Wheels of your limousine liner.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLu-1.webp?alt=media&token=7730f918-c9ca-4125-9713-29dfbb9ffefc",
      },
      {
        title: "Premium Leatherette VIP Seats",
        description:
          "First-class comfort at every mile for you. Relax, sit back and buckle up to soar above the crowd.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLu-2.webp?alt=media&token=955eb03f-90af-4c9c-a976-c77b839e32d1",
      },
      {
        title: "One Touch Power Sliding Doors",
        description:
          "Open up a world of convenience, an effortless onboarding for ultimate extravagance.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLu-3.webp?alt=media&token=ea6ebc1e-88ff-4923-87ea-d20683e8df6a",
      },
      {
        title:
          "Independently Controlled 3-zone Fully-automatic Temperature Control",
        description:
          "A customised climate zone for every mile of your journey.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FLu-4.webp?alt=media&token=39ef09ca-2782-483c-b309-f15e11918c3a",
      },
      {
        title: "8 Airbags",
        description:
          "The ultimate peace of mind wrapped in the luxury of premium protection.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Flu-5.webp?alt=media&token=aed9ee60-f8d2-4c9c-8123-5f1410de91e8",
      },
    ],
  },
];

const CarouselData1 = [
  {
    sub: "EXTERIOR",
    title: "Style that’s sky-high.",
    data: "Soar through the streets with the new Kia Carnival’s exceptionally elegant exterior, and make every drive feel like an ascent.",
    carData: [
      {
        title: "Black and Chrome “Tiger Nose Grille”",
        description:
          "With Black and Chrome coating Tiger Nose Grille, the Kia Carnival takes off from the crowd in many ways than one.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fext002.webp?alt=media&token=bb864bba-ddfd-4147-811c-41faa1cecec3",
      },
      {
        title: "One Touch Sliding Door with Power Tail Gate",
        description:
          "An effortless, and smooth boarding experience, accessible at one touch. ​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fext002.webp?alt=media&token=bb864bba-ddfd-4147-811c-41faa1cecec3",
      },
      {
        title: "Wide Dual Electric Sunroof",
        description:
          "Experience views from a new altitude like never before with the Dual Electric Sunroof. ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fext002.webp?alt=media&token=bb864bba-ddfd-4147-811c-41faa1cecec3",
      },
      {
        title: "18” Diamond Cut Alloy Wheels",
        description:
          "Have a lift-off with striking design that cuts through the road with aerodynamic grace.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fext004.webp?alt=media&token=608aebd8-06e2-4b03-9648-0bfcbe5818ed",
      },
    ],
  },
  {
    sub: "INTERIOR",
    title: "Comfort of the Captain’s Quarters.",
    data: "Designed for premium comfort, and to make every journey a first-class experience, the new Kia Carnival sets the standard for luxury, technology, and extravagance alike.​",
    carData: [
      {
        title: "3 Zone Seating with Tri-Zone Cooling",
        description:
          "Personalized climate control for each zone ensuring a comfortable temperature for every one of your passengers.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fint001.webp?alt=media&token=9361fb04-19de-44eb-8318-38977501b3b5",
      },
      {
        title: "Infotainment System",
        description:
          "An immersive digital command center that elevates every journey with seamless connectivity and entertainment.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fint002.webp?alt=media&token=5cc1f754-25fc-4423-a990-a6854761770c",
      },
      {
        title: "Wireless Charger",
        description:
          "Seamlessly stay connected on the go with an effortless charging station in your cabin.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fint003.webp?alt=media&token=a0d1553e-8753-481f-8806-e382ccaf9868",
      },
      {
        title: "Paddle Shifter",
        description:
          "Enjoy a more engaging driving experience with our Paddle Shifters. Quickly and easily shift gears for optimal performance.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fint004.webp?alt=media&token=7aecbf4a-ac6e-40ce-86d2-080b3a018117",
      },
    ],
  },
  {
    sub: "SAFETY",
    title: "Mile-high Safety.",
    data: "Experience a journey safeguarded by advanced technology, with 23 autonomous ADAS features designed to keep you secure through every mile. The Kia Carnival provides smart protective systems that anticipate your needs on the road, ensuring utmost safety and peace of mind with every drive.",
    carData: [
      {
        title: "8 Airbags",
        description:
          "Safety for the full deck and the cabin alike, making every journey as secure as it is smooth.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fsafe001.webp?alt=media&token=4b32ee7e-a285-4e0b-962a-345903ce3912",
      },
      {
        title: "Rear Cross-Traffic Collision Avoidance System",
        description:
          "Avoid collisions with approaching vehicles when backing up with our advanced Rear Cross-Traffic Collision Avoidance System.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fsafe002.webp?alt=media&token=2dfab77e-6f15-4b8e-9217-9d51692d3e39",
      },
      {
        title: "360-Degree-Camera",
        description:
          "Get an aerial view of your surroundings so that your eyes are not only on the road when you drive but all-around even when you’re not.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fsafe003.webp?alt=media&token=eed857a6-df00-439c-89a2-1c178a9500fd",
      },
      {
        title: "Smart Cruise Control",
        description:
          "Avoid collisions and maintain a safe following distance with our advanced Smart Cruise Control system.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fsafe004.webp?alt=media&token=0e4d4e66-6cc2-4800-9e49-7dd044671b40",
      },
      {
        title: "Lane Keep Assist",
        description:
          "Stay on course with our Lane Keep Assist system. It helps prevent accidental lane departures and keeps you centered in your lane, ensuring a safer and more comfortable drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fsafe005.webp?alt=media&token=e78038f1-d78b-4e66-baa1-fc1e64beaf87",
      },
    ],
  },
];

const TrimData = [
  {
    title: "Limousine Plus",
    cost: "59,42,495",
    feature1: "2nd Row Luxury Powered Relaxation with Leg Support (VIP Seats)",
    feature2: "12.3” AVNT with Kia Connect, India Maps and OTA",
    feature3: "Dual Sunroof",
    feature4: "One Touch Power Sliding Doors- with Hands Free Power Sliding Door function",
    feature5: "ADAS",
    feature6: "8 Airbags",
    feature7: "12.3” Full TFT LCD Cluster",
  },
];

const CircleData = [
  {
    title: "Glacier White Pearl",
    color: "#f3f9fb",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fglaciar%20white.webp?alt=media&token=8b7a6321-954e-45d6-9aa6-54eab75263a9",
  },
  {
    title: "Fusion Black",
    color: "#070708",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Ffusion%20black.webp?alt=media&token=7e7dbdbb-5ff9-4e5a-988b-23767ceca9c7",
  },
];

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Your own luxury liner. ",
    desc: "Book New Carnival Limousine",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Get all what you want to know about New Carnival Limousine",
    link: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/carnival/Kia_Carnival_Brochure_Desktop.pdf",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 0000000000",
    link: "tel:+919237386213",
  },
];

const FaqData = [
  {
    question: "What colors does the 2025 Kia Carnival Limousine come in?",
    answer:
      "New 2025 Kia Carnival Limousine comes in two colors in India, Fusion Black and Glacier White Pearl.",
  },
  {
    question: "What is 2025 Kia Carnival Limousine price in India?",
    answer:
      "Kia Carnival Limousine plus starts at price of ₹ 63 90 000*(Ex-showroom price all India).",
  },
  {
    question: "How many seating options will the Kia Carnival Limousine offer?",
    answer:
      "The New Kia Carnival Limousine is a 7-Seater car, comes in (2+2+3).",
  },
  {
    question:
      "What are the transmission options available in the new Kia Carnival Limousine?",
    answer: "The Kia Carnival Limousine is available in 8AT.",
  },
  {
    question:
      "How many features does the new Carnival Limousine offer in its ADAS system?",
    answer:
      "The new Carnival Limousine comes with 33 autonomous ADAS features designed to keep you secure through every mile.",
  },

  {
    question: "Is there Sunroof in Kia Carnival Limousine?",
    answer:
      "Yes, New Kia Carnival Limousine comes with wide electric dual sunroof.",
  },
];

const StepData = [
  {
    title: "Tiger Nose Grille",
    desc: " With a sleek Black and Chrome  Tiger Nose Grille , the Kia Carnival ascends above the crowd, cruising in a class of its own.",
  },
  {
    title: "360 Degree Camera",
    desc: "Equipped with advanced sensors to keep you aware of potential hazards, ensuring you cruise by automatically adjusting to avoid any collisions.",
  },
  {
    title: " Smart Power Sliding Doors",
    desc: "  A simple touch for a smooth onboarding experience, the Smart Power Sliding Doors glide open for you to step into a first-class experience.",
  },
  {
    title: "LED Rear Combination Lamps",
    desc: " Enhance visibility and style with our advanced LED rear combination lamps, offering a sleek and modern design.",
  },
  {
    title: "Shark Fin Antenna",
    desc: "Merging cutting-edge connectivity with an aerodynamic profile, it exudes subtle elegance.",
  },
  {
    title: "Dual Panoramic Curved Display",
    desc: "Elevate your journey with a display that curves to your view, merging intuitive control with an expansive, panoramic experience.",
  },
];
export {
  CarouselData,
  CarouselData1,
  TrimData,
  CircleData,
  DetailInfo,
  FaqData,
  StepData,
  BannerData,
  IntroData,
  InterestDealerData,
  banner2Data,
};
